import type { PropsWithChildren } from "react";

import { useSelector } from "react-redux";

import { FiltersListEmptyState } from "app/pages/sales-intelligence/common-components/filters-panel/components/FiltersListEmptyState/FiltersListEmptyState";
import type { IFilterManagerModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/services/filters-manager/types";
import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";

import { selectSearchQuery } from "../../store/selectors";

type Props<T extends IPlainObject = IPlainObject> = PropsWithChildren<{
    filtersManager: IFilterManagerModel<T>;
    isLoading?: boolean;
}>;

export const SearchResultsGuard = <T extends IPlainObject = IPlainObject>({
    filtersManager,
    isLoading,
    children,
}: Props<T>) => {
    const searchQuery = useSelector(selectSearchQuery);

    const hasNoFilters = filtersManager.getAll().length === 0;
    const isSearchActive = searchQuery.length > 0;
    const isNoSearchResults = !isLoading && isSearchActive && hasNoFilters;

    if (isNoSearchResults) {
        return <FiltersListEmptyState variant="search" />;
    }

    return children;
};
